module.exports = __webpack_public_path__ + "img/neo.8f7d5ec7.png";